import { useState, useEffect, useCallback } from 'react'
import api from '../lib/api'

const EVENTO_LABEL = {
  'WhatsApp Meta subir archivo response': { label: 'Subir archivo', color: '#6c757d' },
  'WhatsApp envío plantilla':             { label: 'Plantilla (PDF)', color: '#0d6efd' },
  'WhatsApp envío JSON':                  { label: 'JSON',            color: '#198754' },
}

function eventoInfo(evento) {
  for (const [key, val] of Object.entries(EVENTO_LABEL)) {
    if (evento?.includes(key)) return val
  }
  return { label: evento, color: '#6c757d' }
}

export default function WhatsappLogs() {
  const [logs,     setLogs]     = useState([])
  const [loading,  setLoading]  = useState(true)
  const [page,     setPage]     = useState(1)
  const [lastPage, setLastPage] = useState(1)
  const [total,    setTotal]    = useState(0)
  const [expanded, setExpanded] = useState(null)

  const [filters, setFilters] = useState({
    evento: '', telefono: '', status: '', desde: '', hasta: '',
  })

  const cargar = useCallback((p = 1) => {
    setLoading(true)
    const params = { page: p, ...Object.fromEntries(Object.entries(filters).filter(([, v]) => v !== '')) }
    api.get('/whatsapp-logs', { params })
      .then(({ data }) => {
        setLogs(data.data)
        setPage(data.current_page)
        setLastPage(data.last_page)
        setTotal(data.total)
      })
      .catch(() => {})
      .finally(() => setLoading(false))
  }, [filters])

  useEffect(() => { cargar(1) }, [cargar])

  return (
    <div className="content">
      <div className="content-header">
        <h1 className="content-title">Logs de WhatsApp</h1>
        <span style={{ color: 'var(--muted)', fontSize: '13px', alignSelf: 'center' }}>
          {total} registro{total !== 1 ? 's' : ''}
        </span>
      </div>

      {/* Filtros */}
      <form
        onSubmit={e => { e.preventDefault(); cargar(1) }}
        style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '16px', alignItems: 'flex-end' }}
      >
        <select
          className="input"
          value={filters.evento}
          onChange={e => setFilters(f => ({ ...f, evento: e.target.value }))}
          style={{ flex: '0 0 160px' }}
        >
          <option value="">Todos los eventos</option>
          <option value="plantilla">Plantilla (PDF)</option>
          <option value="JSON">JSON</option>
          <option value="subir">Subir archivo</option>
        </select>
        <input
          className="input"
          placeholder="Teléfono…"
          value={filters.telefono}
          onChange={e => setFilters(f => ({ ...f, telefono: e.target.value }))}
          style={{ flex: '0 0 140px' }}
        />
        <select
          className="input"
          value={filters.status}
          onChange={e => setFilters(f => ({ ...f, status: e.target.value }))}
          style={{ flex: '0 0 110px' }}
        >
          <option value="">Todos los status</option>
          <option value="200">200 OK</option>
          <option value="400">400 Error</option>
        </select>
        <input type="date" className="input" value={filters.desde} onChange={e => setFilters(f => ({ ...f, desde: e.target.value }))} style={{ flex: '0 0 130px' }} />
        <input type="date" className="input" value={filters.hasta} onChange={e => setFilters(f => ({ ...f, hasta: e.target.value }))} style={{ flex: '0 0 130px' }} />
        <button type="submit" className="btn btn-primary btn-sm">Filtrar</button>
        <button type="button" className="btn btn-sm" onClick={() => setFilters({ evento: '', telefono: '', status: '', desde: '', hasta: '' })}>Limpiar</button>
        <button type="button" className="btn btn-sm" onClick={() => cargar(page)} style={{ marginLeft: 'auto' }}>↻ Actualizar</button>
      </form>

      {loading && <div style={{ color: 'var(--muted)' }}>Cargando…</div>}

      {!loading && logs.length === 0 && (
        <div className="empty">No hay registros de WhatsApp.</div>
      )}

      {!loading && logs.length > 0 && (
        <>
          <div style={{ overflowX: 'auto' }}>
            <table className="table">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Evento</th>
                  <th>Teléfono</th>
                  <th>Status</th>
                  <th>Resultado</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {logs.map((log, i) => {
                  const info   = eventoInfo(log.evento)
                  const isOpen = expanded === i
                  const ok     = log.status === 200
                  return (
                    <>
                      <tr
                        key={i}
                        style={{ cursor: 'pointer', background: isOpen ? 'var(--hover)' : undefined }}
                        onClick={() => setExpanded(isOpen ? null : i)}
                      >
                        <td style={{ whiteSpace: 'nowrap', fontSize: '12px', color: 'var(--muted)' }}>
                          {log.fecha}
                        </td>
                        <td>
                          <span className="badge" style={{ background: info.color, color: '#fff' }}>
                            {info.label}
                          </span>
                        </td>
                        <td style={{ fontFamily: 'monospace', fontSize: '12px' }}>
                          {log.telefono ? `+${log.telefono}` : (log.filePath ? '—' : '—')}
                        </td>
                        <td>
                          <span className="badge" style={{ background: ok ? '#198754' : '#dc3545', color: '#fff' }}>
                            {log.status ?? '—'}
                          </span>
                        </td>
                        <td style={{ fontSize: '12px', maxWidth: '280px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          {log.error
                            ? <span style={{ color: '#dc3545' }}>{log.error}</span>
                            : log.wamid
                              ? <span style={{ color: 'var(--muted)', fontFamily: 'monospace', fontSize: '11px' }}>{log.wamid.substring(0, 40)}…</span>
                              : log.filePath
                                ? <span style={{ color: 'var(--muted)' }}>{log.filePath.split('/').pop()}</span>
                                : '—'
                          }
                        </td>
                        <td style={{ color: 'var(--muted)', fontSize: '12px' }}>▾</td>
                      </tr>

                      {isOpen && (
                        <tr key={`${i}-detail`}>
                          <td colSpan={6} style={{ background: 'var(--surface-2, #f9f9f9)', padding: '12px 20px' }}>
                            <pre style={{
                              margin: 0, padding: '10px',
                              background: '#1e1e1e', color: '#9cdcfe',
                              borderRadius: '4px', fontSize: '11px',
                              whiteSpace: 'pre-wrap', overflowX: 'auto',
                              maxHeight: '300px', overflowY: 'auto',
                            }}>
                              {JSON.stringify(log.raw, null, 2)}
                            </pre>
                          </td>
                        </tr>
                      )}
                    </>
                  )
                })}
              </tbody>
            </table>
          </div>

          {lastPage > 1 && (
            <div style={{ display: 'flex', gap: '6px', marginTop: '12px', justifyContent: 'center' }}>
              <button className="btn btn-sm" disabled={page <= 1} onClick={() => cargar(page - 1)}>‹ Anterior</button>
              <span style={{ alignSelf: 'center', fontSize: '13px', color: 'var(--muted)' }}>Página {page} / {lastPage}</span>
              <button className="btn btn-sm" disabled={page >= lastPage} onClick={() => cargar(page + 1)}>Siguiente ›</button>
            </div>
          )}
        </>
      )}
    </div>
  )
}
